// src/Components/Modal.js

import React, { useEffect, useRef } from "react";
import { FiX } from "react-icons/fi";
import "../Modal.css";

const Modal = ({ isOpen, onClose, children }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      // Save the element that was focused before opening the modal
      const focusedElement = document.activeElement;
      // Focus the modal
      modalRef.current.focus();
      // Prevent background scrolling
      document.body.style.overflow = "hidden";

      return () => {
        // Restore focus to the previous element
        if (focusedElement) focusedElement.focus();
        // Restore background scrolling
        document.body.style.overflow = "auto";
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        ref={modalRef}
        tabIndex="-1"
      >
        <button
          className="modal-close-button"
          onClick={onClose}
          aria-label="Close Modal"
        >
          <FiX />
        </button>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
